import React,{useState} from "react";
import Icon from "../atoms/Icon";
import EmptyS from "../atoms/EmptyS";
import { isEmpty } from "../../clases/validator";
import { Link } from "react-router-dom";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import "../../index.css";
import { OrderAddUseContext } from "../../context/AdminDashboard/OrderAddContext";

const Table = ({
  thData,

  tableData,
  Hempty,
  emptyText,

  classOPR,

  thwidth,
}) => {
const {value,onchangeInput, handleIncrease,
  handleDecrease}=OrderAddUseContext()
   

   
  return (
    <>
      <div className="border-gray border-1 border-solid rounded-sm">
        <table className=" w-full   text-dark-blue-200 mr-.002 mt-.01">
          <thead className="text-13  bg-gray-300">
            <tr>
              {thData.map((th) => {
                return (
                  <th
                    className={`py-3.5 font-normal text-right first:rounded-r-sm first:pr-7.5px last:pl-7.5px ${thwidth} `}
                    key={th.key}>
                    {th.name}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody className="">
            {tableData.map((data, index) => {
              
              return (
                <tr
                  key={index}
                  className="text-13 font-normal border-b-1 border-gray last:border-b-0">
                  {thData.map((td) => {
                    // console.log(data[device].getOwnerAndGuestNumber)
                    // console.log(td.name)
                    if (td.name === "تعداد انتخاب") {
                      
                      return (
                        <td key={td.key}>
                          <form className="flex h-12.5">
                            <div className="flex flex-row pl-5">
                            <input
                            className="w-5 outline-none justify-center items-center text-center"
                              type="number"
                              value={data.number}
                              
                              readOnly={true}
                              id={data.id}
                            />
                            <span className="flex items-center">دستگاه</span>
                            </div>
                            
                            <div className="flex flex-col justify-center">
                            <button  id={data.id} className="text-16 h-auto" onClick={handleIncrease}>+</button>
                            <button  id={data.id} className="text-16 h-auto" onClick={handleDecrease}>-</button>
                            </div>
                            
                          </form>
                        </td>
                      );
                    } else if (td.name != "تعداد انتخاب") {
                      return (
                        <td
                          className=" py-3.5 font-normal first:pr-7.5px "
                          key={td.key}>
                          {data[td.key]}
                        </td>
                      );
                    }
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Table;
